<template>
  <div class="sns-content-section">
    <sns-content-tabs-parts
      class="sns-content-section__tabs"
      :currentType="snsContentType"
      @select="tabsChange"
    />

    <div
      class="sns-content-section__content"
      :class="{ 'sns-content-section__content__isApp': !isForPC }"
    >
      <sns-driver-section v-if="snsContentType === 'driver'" />

      <sns-team-section v-if="snsContentType === 'team'" />

      <sns-official-section v-if="snsContentType === 'official'" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import SnsContentTabsParts from '@/components/HomePage/HomePane/parts/SnsContentTabsParts.vue'
import SnsDriverSection from '@/components/HomePage/HomePane/SnsDriverSection.vue'
import SnsTeamSection from '@/components/HomePage/HomePane/SnsTeamSection.vue'
import SnsOfficialSection from '@/components/HomePage/HomePane/SnsOfficialSection.vue'
import { SnsTabsType } from '@/store/stores/pageStore/HomePage/HomePageStore'
import StoreUtil from '@/store/StoreUtil'
import DeviceInfo from '@/util/DeviceInfo'

/**
 * HOME SNSコンテンツセクション
 */
export default defineComponent({
  name: 'SnsContentSection',
  components: {
    SnsContentTabsParts,
    SnsDriverSection,
    SnsTeamSection,
    SnsOfficialSection,
  },
  setup() {
    const store = StoreUtil.useStore('HomePageStore')
    const isForPC = DeviceInfo.isForPC()

    const tabsChange = (type: SnsTabsType) => {
      store.currentSnsTab.value = type
    }

    return {
      snsContentType: store.currentSnsTab,
      tabsChange,
      isForPC,
    }
  },
})
</script>

<style lang="scss" scoped>
.sns-content-section {
  position: relative;
  width: 100%;
  padding: 0;

  &__tabs {
    position: sticky;
    left: 0;
    top: 0;
    margin-bottom: 20px;
    z-index: 2;
  }

  &__content {
    position: relative;
    max-width: 580px;
    margin: 0 auto;
    z-index: 1;
    padding-bottom: 120px;

    &__isApp {
      padding-bottom: 24px;
    }
  }
}
</style>
